import { ShiftDigitalService } from '@sm360/widget-commons-general';
import { PurchaseMethods, Vehicle } from '@sm360/widget-commons-vehicle';

const { PurchaseMethodsActions } = PurchaseMethods;
const { TradeInVehicleActions } = Vehicle;

const triggerShiftEvent = (getState, purchaseMethod) => {
    const state = getState();
    const { modelYear, purchaseMethods } = state;
    ShiftDigitalService.updateDrCalculatorStartForBuilder(
        modelYear,
        purchaseMethod || purchaseMethods.getSelectedPurchaseMethod()
    );
};

export function loadPurchaseMethodsSuccess(purchaseMethods) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(purchaseMethods));
    };
}

export function selectPurchaseMethod(purchaseMethod, isNotFromUser) {
    return (dispatch, getState) => {
        if (!isNotFromUser) triggerShiftEvent(getState, purchaseMethod);
        dispatch(PurchaseMethodsActions.selectPurchaseMethod(purchaseMethod));
    };
}

export function selectTerm(term) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActions.selectTerm(term));
    };
}

export function selectPaymentFrequency(paymentFrequency) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActions.selectPaymentFrequency(paymentFrequency));
    };
}

export function setCashDown(cashDown) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActions.setCashDown(cashDown));
    };
}

export function updateTargetPayment(targetPayment) {
    return (dispatch, getState) => {
        const state = getState();
        const purchaseMethods = state.purchaseMethods;
        const calculationParameters = purchaseMethods.getPaymentCalculationParameters();
        const targetCashdown = purchaseMethods.getCashDownFromTargetPayment(targetPayment);
        triggerShiftEvent(getState, purchaseMethods.getSelectedPurchaseMethod());
        if (calculationParameters.cashDown !== targetCashdown) {
            dispatch(PurchaseMethodsActions.setCashDown(targetCashdown));
        }
    };
}

export function setTradeIn(tradeIn) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setTradeIn(tradeIn));
    };
}

export function saveTradeInVehicle(tradeInVehicle) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(TradeInVehicleActions.saveTradeInVehicle(tradeInVehicle));
    };
}

export function setLien(lien) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setLien(lien));
    };
}

export function setExteriorColourAmounts(exteriorColourAmounts) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setExteriorColourAmounts(exteriorColourAmounts));
    };
}

export function setInteriorColourAmounts(interiorColourAmounts) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setInteriorColourAmounts(interiorColourAmounts));
    };
}

export function setOptionsAmounts(optionsAmounts) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setOptionsAmounts(optionsAmounts));
    };
}

export function setTaxesIncluded(taxesIncluded) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActions.setTaxesIncluded(taxesIncluded));
    };
}

export function setKMPlan(kmPlan) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActions.setKMPlan(kmPlan));
    };
}

export function setShiftEvent(isNotFromUser) {
    return (dispatch, getState) => {
        if (!isNotFromUser) triggerShiftEvent(getState);
    };
}
